import { reactive } from 'vue';
import dayjs from 'dayjs';
import { MemberActivity } from '@/types/memberActivity.js';
import { getMemberActivityKey } from '@/utils/memberActivity';

const STORAGE_KEY = 'memberActivityReadStatus';

const isWithinUnreadWindow = (createdAt: string) =>
  dayjs(createdAt) > dayjs().subtract(3, 'day');

const loadReadEntries = (): Record<string, string> => {
  let entries: Record<string, string>;
  try {
    entries = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}');
  } catch {
    entries = {};
  }
  const pruned = Object.fromEntries(
    Object.entries(entries).filter(([, createdAt]) =>
      isWithinUnreadWindow(createdAt),
    ),
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
  return pruned;
};

export const useMemberActivityReadStatus = () => {
  const readEntries = reactive(loadReadEntries());

  const isUnread = (activity: MemberActivity) =>
    isWithinUnreadWindow(activity.created_at) &&
    !(getMemberActivityKey(activity) in readEntries);

  const markAsRead = (activity: MemberActivity) => {
    readEntries[getMemberActivityKey(activity)] = activity.created_at;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(readEntries));
  };

  return { isUnread, markAsRead };
};
